import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * ServiceLocator
 *
 * @hidden
 */
export class ServiceLocator {
    constructor() {
        this.services = {};
    }
    getService(name) {
        if (isNullOrUndefined(this.services[`${name}`])) {
            // eslint-disable-next-line no-throw-literal
            throw `The service ${name} is not registered`;
        }
        return this.services[`${name}`];
    }
    register(name, type) {
        if (isNullOrUndefined(this.services[`${name}`])) {
            this.services[`${name}`] = type;
        }
    }
}
